import React, {createRef} from 'react';
import clsx from "clsx";

export default function LongText(props) {

    const labelRef = createRef();
    const sublabelRef = createRef();

    const data = props.data;
    const updateFormData = props.updateFormData;

    return <div id={data.id} className={clsx('sendiio-form-long-text-element', `sendiio-form-label-alignment-${data.labelAlignment}`)}>
        <label ref={labelRef}
               className={clsx('sendiio-form-short-text-label', 'cursor-text', data.required && 'sendiio-form-element-required')}
               format="text"
               contentEditable={true}
               suppressContentEditableWarning={true}
               onBlur={e => {

                   if(data.label !== e.currentTarget.textContent){

                       data.label = e.currentTarget.textContent;

                       updateFormData(data);

                       labelRef.current.textContent = e.currentTarget.textContent;

                   }

               }}
               dangerouslySetInnerHTML={{__html: data.label}} />
        <div className="sendiio-form-element-wrapper">
            <textarea className="sendiio-form-long-textarea cursor-text"
                   onChange={e => {e.preventDefault()}}
                   id={`textarea-${data.id}-long-text`}
                   name={`${data.id}-long-text`}
                   rows={12}
                   value="">
            </textarea>
            <p  ref={sublabelRef}
                className="sendiio-form-long-text-sublabel cursor-text"
                format="text"
                contentEditable={true}
                suppressContentEditableWarning={true}
                onBlur={e => {

                   if(data.sublabel !== e.currentTarget.textContent){

                       data.sublabel = e.currentTarget.textContent;

                       updateFormData(data);

                       sublabelRef.current.textContent = e.currentTarget.textContent;

                   }

                }}
                dangerouslySetInnerHTML={{__html: data.sublabel}} />
        </div>
    </div>

}